export default Object.freeze({
  gtmId: process.env.REACT_APP_GTM_ID,
});
